import { recipeTypes } from '@/util/constants';
import mutations from './mutations';
import actions from './actions';

const state = {
  draft: {
    name: null,
    unitId: null,
    unit: {},
    type: recipeTypes[0].id, // Default to the first type in the recipeTypes array
    quantity: 0,
    salesPrice: 0,
    image: null,
    items: [],
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
